export enum DeviceEnum {
  mobile = 'mobile',
  desktop = 'desktop',
}

export enum BreakpointEnum {
  desktop = 1040,
  tablet = 768,
}
